<template>
  <div v-if="modalIsOpened" id="teamInfoModal" class="fixed  inset-0 w-full bg-black/30 z-50 ">
    <div class="fixed max-[1000px]:mx-[20px] inset-0 overflow-y-auto flex items-start justify-center py-8" @click.self="closeModal">
      <div class="w-[100vw] max-w-[450px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto h-[615px] box-effect rounded-[10px] bg-white overflow-hidden max-w-[450px]">
          <div class="flex flex-col justify-center items-start gap-[22px] py-[12px] px-[10px] pt-[12px]  pb-[20px]">
            <div class="w-full flex flex-col items-center relative">
              <MedicalKitIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-primary-dark mt-[5px]">ข้อมูลทีม</span>
              <span class="PC_caption-R text-primary-dark">
                {{ `${item?.name || "ไม่พบชื่อทีม"} : ${item?.total_members || 0} คน` }}
              </span>
              <div
                class="absolute right-0 border border-grey-light rounded-md w-9 h-9 flex items-center justify-center cursor-pointer"
                @click="closeModal">
                <XmarkIcon class="w-[12px] h-[12px] text-primary" color="#9B237B" />
              </div>
            </div>

            <div v-if="item?.all_members?.length > 0"
              class="w-full max-h-[473.6px] flex flex-col items-start gap-[12px] overflow-auto pl-2.5">
              <div v-for="(data, index) in item?.all_members" :key="index"
                class="w-full flex items-center justify-between gap-[12px] pr-3">
                <div class="flex items-center">
                  <span class="w-[20px] PC_Body2-R text-[#1F1D1F]"> {{ ++index }} </span>
                  <div class="flex items-center gap-[10px]">
                    <div
                      class="w-[30px] h-[30px] border-[1px] border-solid border-[#F2E7F9] rounded-full overflow-hidden flex items-center justify-center">
                      <img :src="data.default_image ? useUsersStore().defaultImg : data.image"
                        class="w-6 h-6 object-cover" alt="" />
                    </div>
                    <div class="flex flex-col">
                      <span class="PC_Body2-R text-primary-dark">
                        {{ data.fullname }}
                      </span>
                      <span v-if="index === 1" class="PC_caption-R text-[#9B237B]">
                        (หัวหน้าทีม)
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <ButtonComponent :icon="'InfoIcon'" :bClass="'btn_shadow--2'" :iClass="'w-[24px] h-[24px] p-[2px]'"
                    @clicked="() => memberInfo(data)" />
                </div>
              </div>
            </div>
            <div v-else class="w-full flex items-start justify-center  overflow-auto py-[40px]">
              <span class="text-[16px] text-[#7C7379]">ขณะนี้ยังไม่มีข้อมูล</span>

            </div>
            <!-- <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent :label="'ยุบทีม'" :bClass="'btn_shadow--cancel !max-w-[1000px]'" @clicked="warnDeletion" />
              <ButtonComponent :label="'แก้ไขทีม'" :bClass="'btn_shadow--save !max-w-[1000px]'" @clicked="closeModal(),emit('edit', item, true) " />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useTeamStore } from "@/pinia/team";
import { useUsersStore } from "../../pinia/users";
import axios from 'axios'


// const { $validateMsg } = useGlobals();
const teamStore = useTeamStore();
const emit = defineEmits(["success", "info", "edit", "warning"]);

const item = ref({});
const modalIsOpened = ref(false);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  item.value = data;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const memberInfo = async (data) => {
  console.log('memberInfo : ', data);
  emit("info", data);
};

const warnDeletion = async () => {
  await axios.get(`/team/${item.value.id}/check-appointment`).then((res) => {
    console.log(res);
    if (res.status === 200) {
      emit("warning", res.data.message)
    }
  }).catch((err) => {
    emit("warning", err.response.data.message)
  })
}

const deleteTeam = async () => {
  await teamStore.deleteTeam(item.value.id).then((response) => {
    if (response.status === 200) {
      emit("success", response.data.message);
      closeModal();
    }
  })
    .catch((error) => {
      emit("warning", error.response.data.message);
      console.log("error", error);
    });
};

defineExpose({ openModal, closeModal });

</script>

<style lang="scss" scoped>
.label {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
  letter-spacing: 0.1px;
}

.addBtn {
  display: flex;
  min-width: 150px;
  min-height: 50px;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #9b237b;
  background: #fbeff8;
}
</style>